import { render, staticRenderFns } from "./TravelerInformations.vue?vue&type=template&id=1061eb04&scoped=true"
import script from "./TravelerInformations.vue?vue&type=script&lang=js"
export * from "./TravelerInformations.vue?vue&type=script&lang=js"
import style0 from "./TravelerInformations.vue?vue&type=style&index=0&id=1061eb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1061eb04",
  null
  
)

export default component.exports